import { useQuery } from 'react-query';

import { categoriesToOptionsConverter } from '../../../utils/categoriesToOptionsConverter';

import { getHoursCategory } from 'RestAPIs/dutyHourTypes';

import { Option } from 'components/shared/ControlledFields/ControlledSelect';

export const useGetHoursCategorySvcOptions = () =>
  useQuery<Option[]>({
    queryKey: ['hours-category', 'options'],
    queryFn: async () =>
      await getHoursCategory().then(categoriesToOptionsConverter({})),
    staleTime: Infinity
  });
